module.exports = __webpack_public_path__ + "static/img/pic19.2.22693f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic19.2.png
// module id = wgaw
// module chunks = 0